import graphql from "babel-plugin-relay/macro";

const DocumentsForReviewCSVQuery = graphql`
  query DocumentsForReviewCSVQuery($justMine: Boolean) {
    documentsToReviewCsv(justMine: $justMine) {
      taskId
    }
  }
`;

export default DocumentsForReviewCSVQuery;
